import { gql } from '@apollo/client'

import { INGREDIENT_SPECIAL_CASE_FRAGMENT } from '../fragments'

const CREATE_INGREDIENT_SPECIAL_CASE_MUTATION = gql`
  mutation createIngredientSpecialCase($data: IngredientSpecialCaseInput!) {
    createIngredientSpecialCase(data: $data) {
      ...IngredientSpecialCaseFragment
    }
  }
  ${INGREDIENT_SPECIAL_CASE_FRAGMENT}
`

export default CREATE_INGREDIENT_SPECIAL_CASE_MUTATION
